document.addEventListener('DOMContentLoaded', function () {
    loadYoutubeData();

    document.querySelector('.grid__more').addEventListener('click', function () {
        loadYoutubeData();
    });

    function loadYoutubeData() {
        const nextPageToken = document.getElementById('nextYoutube').value;
        const apiUrl = 'https://www.googleapis.com/youtube/v3/playlistItems?';
        const params = new URLSearchParams({
            part: 'snippet',
            playlistId: 'UUxux22TkA0Xeg2WjbJpiVTg',
            key: 'AIzaSyCRlamQMaomCLJQUffvORhiTgZWHXpXIZY',
            pageToken: nextPageToken,
            maxResults: 12,
        });

        fetch(apiUrl + params.toString())
            .then((response) => {
                if (!response.ok) {
                    throw new Error('네트워크 응답에 문제가 있습니다');
                }
                return response.json();
            })
            .then((data) => {
                renderYoutubeItems(data.items, data.nextPageToken);
            })
            .catch((error) => {
                console.error('데이터를 가져오는 중 오류 발생:', error);
            });
    }

    function renderYoutubeItems(items, nextPageToken) {
        const itemList = document.getElementById('itemList');

        document.getElementById('nextYoutube').value = nextPageToken || '';

        const moreButton = document.querySelector('.grid__more');
        if (!nextPageToken) {
            moreButton.style.display = 'none';
        } else {
            moreButton.style.display = 'block';
        }

        items.forEach((item, index) => {
            const videoId = item.snippet.resourceId.videoId;
            const title = item.snippet.title;
            const thumbnailUrl = item.snippet.thumbnails.medium.url;
            const publishedDate = new Date(item.snippet.publishedAt);
            const formattedDate = `${publishedDate.getFullYear()}.${String(publishedDate.getMonth() + 1).padStart(2, '0')}.${String(publishedDate.getDate()).padStart(2, '0')}`;

            const gridItem = document.createElement('div');
            gridItem.className = 'grid-item';

            gridItem.innerHTML = `
            <a
                style='display:block'
                href='https://www.youtube.com/watch?v=${videoId}'
                target='_blank'
                title='${title} 유투브 새창 바로가기'
                id='listItemId_1_${index}'
                ap-click-area='Lounge'
                ap-click-name='Click - Lounge'
                ap-click-data='${videoId}'>
                <div class='item item-youtube'>
                    <div class='item__image'>
                        <img
                            src='${thumbnailUrl}'
                            alt=''>
                        <div class='item__image--badge'><span class='ap2022-sr-only'>Youtube</span></div>
                    </div>
                    <div class='item__content'>
                        <strong>${title}</strong>
                        <div class='item__content--date'>${formattedDate}</div>
                    </div>
                </div>
            </a>
        `;

            itemList.appendChild(gridItem);
        });

        initMasonry();
    }

    function initMasonry() {
        const grid = document.querySelector('.grid');
        const masonry = new Masonry(grid, {
            itemSelector: '.grid-item',
            columnWidth: '.grid-item',
            // gutter: 20,
            // percentPosition: true,
        });

        imagesLoaded(grid).on('progress', function () {
            masonry.layout();
        });
    }
});